import { api } from '@/lib/api';
import type {
  Organization,
  OrganizationListResponse,
  CreateOrganizationDTO,
  UpdateOrganizationDTO,
} from '../types';

export const organizationApi = {
  list: async (): Promise<OrganizationListResponse> => {
    return api.get<OrganizationListResponse>(
      '/admin/organizations?include_inactive=true'
    );
  },

  create: async (data: CreateOrganizationDTO): Promise<Organization> => {
    return api.post<Organization>('/admin/organizations', data);
  },

  update: async (
    organizationId: number,
    data: UpdateOrganizationDTO
  ): Promise<Organization> => {
    return api.put<Organization>(
      `/admin/organizations/${organizationId}/`,
      data
    );
  },

  delete: async (organizationId: number): Promise<void> => {
    return api.delete<void>(`/admin/organizations/${organizationId}`);
  },
};
